export enum AppRole {
  SuperAdmin = 'SuperAdmin',
  RegionalAdmin = 'RegionalAdmin',
  RegionalManager = 'RegionalManager',
  Supervisor = 'Supervisor',
  MaterialDispatcher = 'MaterialDispatcher',
  LaborCoordinator = 'LaborCoordinator',
  SupplierRepresentative = 'SupplierRepresentative',
  SupplyProTester = 'SupplyProTester',
  BuilderSupervisor = 'BuilderSupervisor',
  AccountingViewOnly = 'AccountingViewOnly',
  Bumper = 'Bumper',
}
